export const LOAD_OFFER_PARTNER_INCOME_TYPES_SUCCEEDED = "LOAD_OFFER_PARTNER_INCOME_TYPES_SUCCEEDED";
export const LOAD_OFFER_PARTNER_INCOME_DATA_SUCCEEDED = "LOAD_OFFER_PARTNER_INCOME_DATA_SUCCEEDED";

export const OFFER_PARTNER_INCOME_TYPE_UPDATE_STARTED = "OFFER_PARTNER_INCOME_TYPE_UPDATE_STARTED";
export const OFFER_PARTNER_INCOME_TYPE_UPDATE_SUCCEEDED = "OFFER_PARTNER_INCOME_TYPE_UPDATE_SUCCEEDED";
export const OFFER_PARTNER_INCOME_TYPE_UPDATE_FAILED = "OFFER_PARTNER_INCOME_TYPE_UPDATE_FAILED";

export const UPDATE_OFFER_PARTNER_INCOME_DATA_STARTED = "UPDATE_OFFER_PARTNER_INCOME_DATA_STARTED";
export const UPDATE_OFFER_PARTNER_INCOME_DATA_SUCCEEDED = "UPDATE_OFFER_PARTNER_INCOME_DATA_SUCCEEDED";
export const UPDATE_OFFER_PARTNER_INCOME_DATA_FAILED = "UPDATE_OFFER_PARTNER_INCOME_DATA_FAILED";

export const UPDATE_OFFER_PARTNER_SALARY_DATA_STARTED = "UPDATE_OFFER_PARTNER_SALARY_DATA_STARTED";
export const UPDATE_OFFER_PARTNER_SALARY_DATA_SUCCEEDED = "UPDATE_OFFER_PARTNER_SALARY_DATA_SUCCEEDED";
export const UPDATE_OFFER_PARTNER_SALARY_DATA_FAILED = "UPDATE_OFFER_PARTNER_SALARY_DATA_FAILED";
